import React from 'react';
import { CardWrapper } from '@monorepo/common';
import { Button, Stack, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { book } from '../../routers/books';
import { getPrepaidPurchasePath } from '../../utils/jobAccountRoutes';

export const NoRemaining = () => {
  const { search } = useLocation();
  const siteId = Number(new URLSearchParams(search).get('siteId')) || null;

  return (
    <CardWrapper
      dataCy="final_step_for_page_postJobListing"
    >
      <Typography
        variant="h4"
        marginBottom={2}
      >
        No Remaining Prepaid Listings
      </Typography>
      <Typography color="text.secondary" marginBottom={3}>
        You have used every listing in this prepaid package. Purchase another package
        to continue posting jobs, or review your existing packages and listings.
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
        <Button component={Link} to={getPrepaidPurchasePath(siteId)} variant="contained">
          Buy a Job Package
        </Button>
        <Button component={Link} to={book.jobsPrepaid} variant="outlined">
          View Prepaid Packages
        </Button>
        <Button component={Link} to={book.jobsListings} variant="text">
          Manage Job Listings
        </Button>
      </Stack>
    </CardWrapper>
  );
};
